import { useEffect } from "react";
import { StatisticsSection } from "@/components/landing/StatisticsSection";

export default function RidesharingImpact() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Ridesharing Impact — Duri Ridesharing";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-cream font-roboto">
      <main>
        <StatisticsSection />
      </main>
    </div>
  );
}
